import { defineMessages, IntlShape } from "react-intl";

import { getDisplayName } from "@app/util/ui";

import { RouteStatus } from "./getRouteStatus";

// IDs kept from the cell renderer that first held them, so the existing
// translations survive.
const messages = defineMessages<RouteStatus>({
  done: {
    id: "routes.listView.status.done",
    defaultMessage: "Done",
    description: "Route status — all stops checked off",
  },
  inProgress: {
    id: "routes.listView.status.inProgress",
    defaultMessage: "In Progress",
    description: "Route status — some but not all stops checked off",
  },
  notStarted: {
    id: "routes.listView.status.notStarted",
    defaultMessage: "Not started",
    description: "Route status — no stops checked off",
  },
});

const getRouteStatusDisplayName = (intl: IntlShape, status: RouteStatus): string =>
  getDisplayName(intl, messages, status, "RouteStatus");

export default getRouteStatusDisplayName;
